import { makeStyles } from '@material-ui/core';
import { themeColor } from 'src/mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  itemListWrapper: {
    flex: '1 1 100%',
    maxWidth: '100%',
  },
  customerLoyalty: {
    zIndex: 500,
    height: '6.78vh',
    flexGrow: 0,
    flexWrap: 'wrap',
    '@media (max-height: 700px)': {
      minHeight: '48px',
    },
  },
  itemListSaleMode: {
    height: '58.84vh',
  },
  total: {
    flexGrow: 0,
  },
  totalSaleMode: {
    flexGrow: 0,
    height: 'auto',
  },
  container: {
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
    height: '100%',
  },
}));
